import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { dayjsUtils } from '@src/shared/utils/helpers/dayjs';
import type { TLeadNote } from '@src/shared/types/lead-note';

export const NoteCardHeaderProfileInfo = ({ note }: { note: TLeadNote }) => {
  const creator = note.created_by_partner ?? note.created_by;

  const firstName = creator?.first_name;
  const lastName = creator?.last_name;
  const avatar = creator?.avatar;

  const formattedDate = dayjsUtils(note.created_at).format('D MMM YYYY');

  return (
    <div className='flex items-center gap-2'>
      <Avatar className='size-7'>
        <AvatarImage src={avatar} />
        <AvatarFallback
          className='text-2xl'
          colorId={note.id}
        >
          {firstName?.charAt(0)}
        </AvatarFallback>
      </Avatar>

      <div className='flex flex-col text-sm items-start text-gray-800  truncate'>
        <span className='font-medium'>
          {firstName} {lastName}
        </span>

        <span className='text-gray-600 text-xs'>{formattedDate}</span>
      </div>
    </div>
  );
};
